import React, {
    Fragment, PureComponent,
} from 'react';
import {
    Col, DatePicker, Form,
    message, Row, Select,
} from 'antd'
import moment from 'moment'
import {
    flight_iata_searching_api_response
} from '../../helper/api_v1/flight_search'
import demestic_flight from './../../json/demestic_flight'




export default class ComSearching extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            searhc_1: false,
            searhc_2: false,

            demestic_flight: demestic_flight,
            origin: "",
            destination: "",
            end_time: moment(),
            classes: "Economy"
        }
    }

    setForSearch = async (e) => {

        this.state.origin === "" ?
            this.setState({ searhc_1: true }) :
            this.setState({ searhc_2: true })

        let search = await flight_iata_searching_api_response({ searching: e.toUpperCase() })

        if (
            Array.isArray(search.iata) && 
            search.iata.length !== 0
        ) {

            this.setState({
                demestic_flight: search.iata
            })

        } else {
            
            this.setState({
                demestic_flight: demestic_flight
            })

        }
        
        this.state.origin === "" ?
            this.setState({ searhc_1: false }) :
            this.setState({ searhc_2: false })
    }


    render() {
        let {
            demestic_flight,
            searhc_1,
            searhc_2
        } = this.state


        return (
            <Fragment>
                <Form layout="vertical">
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <Form.Item label="Origin">
                                <Select
                                    showSearch
                                    placeholder="Select Origin"
                                    style={{ width: "100%", }}
                                    loading={searhc_1}
                                    onSearch={(e) => this.setForSearch(e)}
                                    onChange={(value) => {
                                        this.setState({
                                            demestic_flight: demestic_flight,
                                            origin: value.toUpperCase(),
                                            searhc_1: false
                                        }, () => {
                                            this.props.search(this.state)
                                        })
                                    }}
                                >
                                    {
                                        demestic_flight.map(data =>
                                            <Select.Option
                                                key={data.iata_code}
                                                value={data.iata_code}
                                            >
                                                {data.municipality} ({data.iata_code})
                                        </Select.Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <Form.Item label="Destination">
                                <Select
                                    showSearch
                                    placeholder="Select Destination"
                                    onSearch={(e) => this.setForSearch(e)}
                                    style={{ width: "100%" }}
                                    loading={searhc_2}
                                    onChange={(value) => {
                                        this.setState({
                                            demestic_flight: demestic_flight,
                                            destination: value.toUpperCase(),
                                            searhc_2: false
                                        }, () => {
                                            this.props.search(this.state)
                                        })
                                    }}
                                >
                                    {
                                        this.state.origin !== "" ?
                                            // eslint-disable-next-line
                                            demestic_flight.map((data) => {
                                                if (data.iata_code !== this.state.origin) {
                                                    return (
                                                        <Select.Option
                                                            key={data.iata_code}
                                                            value={data.iata_code}
                                                        >
                                                            {data.municipality} ({data.iata_code})
                                                        </Select.Option>
                                                    )
                                                }
                                            })
                                            : <Select.Option disabled value="">Not Selected</Select.Option>
                                    }
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <Form.Item label="Departing Date">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    placeholder="Departing Date"
                                    defaultValue={moment().startOf('day')}
                                    disabledDate={(current) => current && current < moment().startOf('day')}
                                    onChange={(_, dateString) => {
                                        this.setState({ end_time: dateString }, () => {
                                            this.props.search(this.state)
                                        })
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={8} xl={8} style={{ margin: 2 }} hidden>
                            <Form.Item label="Class (optional)">
                                <Select
                                    defaultValue="Economy"
                                    onChange={(value) => this.setState({ classes: value })}
                                    style={{ width: "100%", }}
                                >
                                    <Select.Option key="1" value="Economy">Economy</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Fragment>
        )
    }
}